import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '../../../../components/CiscoUi';
import { Search } from '../../../../components/Search';
import { MainRoutes } from '../../../../constants/routes';
import { useFilter } from '../../../../hooks/use-filter';
import { CreateTopologyRoutes } from '../../constants';
import { ImportDemosTable } from './components/DemosTable';

export interface DemoImportProps {
  demos: InventoryDemo[];
  isLoading: boolean;
  setDemoToImport: (demo: InventoryDemo) => void;
}

export function DemoImport({
  demos,
  isLoading,
  setDemoToImport,
}: DemoImportProps): ReactElement {
  const { t } = useTranslation();
  const { filteredItems, handleSearchChange, searchValue } = useFilter({
    filterKeys: ['name', 'id'],
    items: demos,
  });

  return (
    <>
      <div className="row flex-center">
        <Search
          className="base-padding"
          id="demo-import-search"
          onChange={(e) => handleSearchChange(e.target.value)}
          placeholder={t('common.search')}
          value={searchValue}
        />
        <ImportDemosTable
          setDemoToImport={setDemoToImport}
          demos={filteredItems}
          isLoading={isLoading}
        />
      </div>
      <div className="text-center dbl-margin-top">
        <LinkButton to={MainRoutes.Topologies} colour="ghost" size="large">
          {t('buttons.cancel')}
        </LinkButton>
        <LinkButton
          to={`${MainRoutes.CreateTopology}${CreateTopologyRoutes.DemoType}`}
          colour="ghost"
          size="large"
          testId="create-topology-demo-type-back-button"
        >
          {t('buttons.back')}
        </LinkButton>
      </div>
    </>
  );
}
